import { useContext, useEffect, useState } from "react";
import { EmployerContext } from "../../Store/EmployerContext";
import WheelColaboradores from "./Components/Wheel/WheelColaboradores";
import Loading from "../../Components/Loading/Loading";

import { HiOutlineMail } from "react-icons/hi";
import { AiFillFacebook, AiOutlineCloseCircle, AiOutlineEdit, AiOutlineInstagram, AiOutlineLinkedin, AiOutlineSend } from "react-icons/ai";
import { IoLogoWhatsapp } from "react-icons/io";
import { getCandidateProfesionalExperiences } from "../../API/Candidates/Experience";
import { getAreaList } from "../../API/Lists/area";
import { Link, useHistory } from "react-router-dom";
import { getCandidateInfo } from "../../API/Candidates/Cadidate";
import { getCandidateAreas, patchCandidateAreas } from "../../API/Candidates/Areas";
import { homePagePersonalTranslate, personalInfoTranslate } from "../../i18n/translatedMessages";
import { useIntl } from "react-intl";

const FilePersona = () => {
  const history = useHistory();
  const language = useIntl();
  const { actions } = useContext(EmployerContext);
  const [loading, setLoading] = useState(false);
  const [candidateImage, setCandidateImage] = useState("");
  const [candidateProfExp, setCandidateProfExp] = useState();
  const [areaList, setAreaList] = useState([]);
  const [areaAddedList, setAreaAddedList] = useState([]);

  const [interests, setInterests] = useState([]);
  const [editInterests, setEditInterests] = useState(false);

  const profileEmpty = {
    name: "",
    mail: "",
    phone: "",
    address: "",
    city: "",
    country: null,
    nationality: "",
    gender: null,
    birth: "",
    family_composition: "",
    profile_image: "",
    special_needs: "",
    pcdResp: false,
    person_with_disability: "",
    national_identification: null,
    civil_status: null,
    image: null,
  };

  const [candidateInfo, setCandidateInfo] = useState(profileEmpty);

  useEffect(() => {
    const requests = async () => {
      setLoading(true);
      const candidateDataAux = await getCandidateInfo(localStorage.getItem("candidateId"));
      const candidateProfExpData = await getCandidateProfesionalExperiences(localStorage.getItem("candidateId"));
      const interestAreasAux = await getCandidateAreas(localStorage.getItem("candidateId"));
      const areaListAux = await getAreaList();
      const filterArea = areaListAux
        ?.filter((areaFilt) => interestAreasAux?.items?.some((item) => item === areaFilt.id))
        .map((ar) => {
          return { name: ar.profileArea };
        });
      setInterests(filterArea);
      setAreaList(areaListAux);
      setAreaAddedList(areaListAux);
      setCandidateInfo(candidateDataAux.item ? candidateDataAux.item : profileEmpty);
      setCandidateImage(candidateDataAux?.item?.image);
      setCandidateProfExp(candidateProfExpData?.items?.professional_experiences);

      if (candidateDataAux?.item?.registration_stage !== "Finished" || candidateDataAux?.item?.registration_stage === null || !candidateDataAux?.item?.registration_stage) {
        history.push("candidate/first-login");
      }
      setLoading(false);
    };
    requests();
  }, []);

  const areaFilter = async () => {
    const filterArea = areaList
      ?.filter((areaFilt) => !interests.some((item) => item.name === areaFilt.profileArea))
      .map((ar) => {
        return ar;
      });
    setAreaAddedList(filterArea);
  };

  useEffect(() => {
    areaFilter();
  }, [interests]);

  const handleMenu = (event) => {
    actions.setOptions(event.currentTarget.dataset.option);
  };

  const handleExp = () => {
    if (candidateProfExp) {
      const actualExp = candidateProfExp
        ?.filter((actFilt) => actFilt.departure_date === "Actual")
        .map((act) => {
          return act;
        });
      if (actualExp.length > 0) {
        const expAux = actualExp[actualExp.length - 1];
        var date = new Date(expAux?.entry_date);
        var elapsed = date.getFullYear();
        return {
          company: expAux?.company,
          jobname: expAux?.jobname,
          startAt: elapsed,
          actual: true,
        };
      } else {
        const profExpAux = candidateProfExp[candidateProfExp.length - 1];
        return {
          company: profExpAux?.company,
          jobname: profExpAux?.jobname,
          startAt: profExpAux?.entry_date,
          departureAt: profExpAux?.departure_date,
          actual: false,
        };
      }
    }
    return false;
  };

  const handleSelect = (item) => {
    const interAux = [...interests];
    if (interests.length < 4) {
      if (item !== 0) {
        interAux.push({ name: item });
        setInterests(interAux);
      }
    }
  };

  const handleSend = async () => {
    const filterArea = areaList
      ?.filter((areaFilt) => interests.some((item) => item.name === areaFilt.profileArea))
      .map((ar) => {
        return ar.id;
      });
    const resp = await patchCandidateAreas(localStorage.getItem("candidateId"), filterArea);
    setEditInterests(false);
  };

  const handleRemoveInterest = (item) => {
    const array = [...interests];
    array.splice(item, 1);
    setInterests(array);
  };

  return (
    <div className="container-fluid FilePersonaMain h-100 d-flex flex-column">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="row justify-content-between">
            <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4">
              {candidateInfo?.name !== "" && (
                <>
                  <div>
                    <h3>{candidateInfo?.name}</h3>
                    <h5 className="color-grey">
                      {candidateProfExp && candidateProfExp.length > 0 ? (
                        handleExp() && handleExp().actual ? (
                          <>
                            <strong>{handleExp()?.jobname}</strong> {language.locale === "PT-BR" ? "em" : "en"} <strong>{handleExp()?.company}</strong> desde {handleExp()?.startAt}
                          </>
                        ) : (
                          <>
                            {homePagePersonalTranslate.workAs} <strong>{handleExp()?.jobname}</strong> {language.locale === "PT-BR" ? "em" : "en"}{" "}
                            <strong>{handleExp()?.company}</strong> de {handleExp()?.startAt} a {handleExp()?.departureAt}
                          </>
                        )
                      ) : (
                        ""
                      )}
                    </h5>
                  </div>
                </>
              )}

              <h5 className="d-flex align-items-center">
                {homePagePersonalTranslate.areasInterest}{" "}
                {!editInterests && (
                  <button className="btn ms-1 enableEditingInterest" onClick={() => setEditInterests(!editInterests)}>
                    <AiOutlineEdit size={20} />
                  </button>
                )}
              </h5>
              <div className="row row-cols-3">
                {interests.map((inte, key) => {
                  return (
                    <div key={key} className="col-auto mb-1">
                      <button className="btn rounded-pill mb-1 btnInterest zIndexAdjust" onClick={editInterests ? () => handleRemoveInterest(key) : undefined}>
                        {"#" + inte.name} {editInterests && <AiOutlineCloseCircle />}
                      </button>
                    </div>
                  );
                })}
                {editInterests && (
                  <div className="col-12 mt-3 align-items-center d-flex">
                    <select value={0} onChange={(e) => handleSelect(e.target.value)}>
                      <option value={0}>Seleccionar Área</option>
                      {areaAddedList?.map((ar, key) => {
                        return (
                          <option key={key} value={ar?.profileArea}>
                            {ar?.profileArea}
                          </option>
                        );
                      })}
                    </select>
                    <button className="btn ms-1 disableEditingInterest rounded-pill pt-0 pb-1" onClick={() => handleSend()}>
                      <AiOutlineSend size={20} />
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4">
              <div className="d-flex justify-content-center mt-4">
                <WheelColaboradores handleMenu={handleMenu} employeeImg={candidateImage} />
              </div>
            </div>
            <div className="col-md-4 d-flex justify-content-end">
              <ul className="list-group  list-group-horizontal wheelEmployeePage-list">
                <li className="list-group-item bg-transparent px-3 py-2 border-0">
                  <a href={candidateInfo?.mail ? "mailto:" + candidateInfo?.mail : null} target="_blank" rel="noreferrer">
                    <HiOutlineMail size={35} color={candidateInfo?.mail ? "#7A6BE8" : "#D9D9E2"} />
                  </a>
                </li>
                <li className="list-group-item bg-transparent px-3 py-2 border-0">
                  <a href={candidateInfo?.network?.linkedin ? candidateInfo?.network?.linkedin : null} target="_blank" rel="noreferrer">
                    <AiOutlineLinkedin size={35} color={candidateInfo?.network?.linkedin ? "#7A6BE8" : "#D9D9E2"} />
                  </a>
                </li>
                <li className="list-group-item bg-transparent px-3 py-2 border-0">
                  <a href={candidateInfo?.network?.facebook ? candidateInfo?.network?.facebook : null} target="_blank" rel="noreferrer">
                    <AiFillFacebook size={35} color={candidateInfo?.network?.facebook ? "#7A6BE8" : "#D9D9E2"} />
                  </a>
                </li>
                <li className="list-group-item bg-transparent px-3 pb-2 border-0">
                  <a href={candidateInfo?.network?.instagram ? candidateInfo?.network?.instagram : null} target="_blank" rel="noreferrer">
                    <AiOutlineInstagram size={35} color={candidateInfo?.network?.instagram ? "#7A6BE8" : "#D9D9E2"} />
                  </a>
                </li>
                <li className="list-group-item bg-transparent px-3 pb-2 border-0">
                  <a target="_blank" rel="noreferrer" href={`https://wa.me/` + candidateInfo?.phone}>
                    <IoLogoWhatsapp size={35} color={candidateInfo?.phone ? "#27E6C4" : "#D9D9E2"} />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="row justify-content-between lastRowAdjust">
            <div className="col-auto">
              <div className="mb-2">
                <Link to={"/candidate/candidatecv"} className="btn rounded-pill btnResume px-4">
                  <h4 className="m-0">{homePagePersonalTranslate.myResume}</h4>
                </Link>
              </div>
              <div className="mb-2">
                <Link to={"/candidate/edit-profile"} className="btn rounded-pill btnEditProfile px-4">
                  <h4 className="m-0">{personalInfoTranslate.personalInformation} </h4>
                </Link>
              </div>
            </div>
            <div className="col-auto text-end">
              <div className="mb-2">
                <Link to={"/candidate/opportunities"} className="btn rounded-pill btnVacantes px-4">
                  <h4 className="m-0">{homePagePersonalTranslate.showVacancies}</h4>
                </Link>
              </div>
              <div className="mb-2">
                <Link to={"/candidate/show-me-the-money"} className="btn rounded-pill btnSalary px-4">
                  <h4 className="m-0">{homePagePersonalTranslate.salaryConsult}</h4>
                </Link>
              </div>
              <div>
                <Link to={"/candidate/genes"} className="btn rounded-pill btnEditProfile px-4">
                  <h4 className="m-0">Outplacement Digital</h4>
                </Link>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default FilePersona;
